import { BMEventsType, type CustomPerformanceEventConfig } from '../types';

export const isCustomConfig = (data: any): data is CustomPerformanceEventConfig => {
	return data.type === BMEventsType.CUSTOM;
};
